<template>

 <div>
	 <v-dialog title="课程余额结转" v-model="hideShow" width="600px" persistent scrollable>
		<v-card class="fc-dialog-card">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-swap-horizontal</v-icon></span><div><h2>课时结转</h2><p>将剩余课时转入其他课程账户</p></div><v-spacer /><v-btn icon aria-label="关闭课时结转" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12">
						<span class="fc-form-note">注:将剩余课时全部转入目标课程账户</span>
					</v-col>
				</v-row>
				<v-row dense v-if="account" class="">
					<v-col cols="6">
						<v-text-field label="学员姓名" v-model="account.studentName" disabled dense outlined color="#d9363e" aria-label="学员姓名"></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field label="课程名称" v-model="account.courseName" disabled dense outlined color="#d9363e" aria-label="课程名称"></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field label="课时余额" v-model="account.balanceHour" disabled dense outlined color="#d9363e" aria-label="课时余额"></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field label="金额余额" v-model="account.balanceFee" disabled dense outlined color="#d9363e" aria-label="金额余额"></v-text-field>
					</v-col>
					<v-col cols="12" class="">
						<v-select :items="availiableCourseList" v-model="transfer.courseId" item-text="courseName"
							item-value="id" label="转入课程名称" dense outlined color="#d9363e" aria-label="转入课程名称"></v-select>
					</v-col>
					<v-col cols="12" class="">
						<v-text-field label="备注" v-model="transfer.memo" dense outlined color="#d9363e" aria-label="备注"></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="cancel" outlined color="#65758c">取消</v-btn>
				<v-btn @click="submitTransfer" :disabled="transfer.submitting" :loading="transfer.submitting" depressed class="fc-confirm" color="#d9363e">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
 </div>

</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"course-account-transfer",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			account:{
				type:Object,
				default:null
			}
		},
		watch:{
			show(newVal,oldVal){
			
				this.hideShow = newVal;
				if(this.hideShow){
					this.transfer.courseId = "";
					this.currentCourseId = this.account.courseId;
					
					this.filterCourse();
					
				}
			}
		},
		data(){
			return {
				shopId:"",
				hideShow:this.show,
				currentCourseId:"",
				transfer:{
					submitting:false,
					courseId:"" ,//  转入的课程ID
					memo:""
				},
				selectCourseList:[],
				availiableCourseList:[]
			}
		},
		
		mounted() {
			console.log("account transfer mounted");
			this.shopId = utils.getCurrentShopId();
			this.getCourseListForSelect();
		},
		methods:{
			cancel(){
				this.$emit("cancel","");
			},
			filterCourse(){
				 
				let res = this.selectCourseList.filter((item)=>{
					return item.id != this.currentCourseId
				})
				
				this.availiableCourseList = res;
				
			},
			submitTransfer(){
				
				this.transfer.submitting = true;
				
				
				let postData = {
					sourceAccountId:this.account.id,
					targetCourseId:this.transfer.courseId,
					memo:this.transfer.memo
				}
				// api
				const that = this;
				let url = `/financial/course/account/transfer`;
					
				this.axios.post(url, postData).catch(() => {
					that.transfer.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							
							that.transfer.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.transfer.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.transfer.submitting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
			},
			getCourseListForSelect() {
				if (!this.shopId) {
					return
				}
				const that = this;
				let url = `/edu/shop/course/list/` + this.shopId;
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						
						const list = response.data["data"] ? response.data["data"] : [];
						
						console.log("current courseId:",that.currentCourseId);
						list.forEach((item,index)=>{
							if (item.consumeType == '1' && item.status == '1' && item.id != that.currentCourseId){
								that.selectCourseList.push(item);
							}
						})
						
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/course-account-dialog.scss"></style>
